import { FieldRenderProps } from '@progress/kendo-react-form';
import { ListBox, ListBoxItemClickEvent, ListBoxToolbar } from '@progress/kendo-react-listbox';
import React, { FC, useEffect } from 'react'
import { UserApi } from '../../../redux/api/UserApi';
import { useReduxDispatch } from '../../../redux/hooks';
import { IStaff } from '../../../types/IStaff';
import * as TicketSlice from '../../../slices/TicketSlice';
import UserFynd from './UserFynd';

const BulkContacts: FC<FieldRenderProps> = props => {
    const {
        bulkContactIds,
        onChange,
    } = props;

    const dispatch = useReduxDispatch();
    const { data: bulkUsers } = UserApi.useGetUsersByIdsQuery(bulkContactIds?.length ? bulkContactIds?.join(',') : '0');
    //const { data: assContactConfig } = Api.useGetAssContactConfigQuery(companyTypeId, { skip: !companyTypeId });
    //const [filter, setFilter] = useState<FilterDescriptor>(null);
    //const [contactsIds, setContactIds] = React.useState(bulkContactIds || []);
    const [selectedId, setSelectedId] = React.useState();
    const SELECTED_FIELD = "selected";
    const bulkUsersFormatted = setDisplayName(bulkUsers) || [];

    function setDisplayName(data) {
        return data?.map(a => {
            return {
                ...a,
                "Display_Name":
                    a[a.Secondary_User_Classification] ?
                        `${a.FullName} - ${a[a.Secondary_User_Classification]}`
                        : a.FullName,
                [SELECTED_FIELD]: a.ID === selectedId
            }
        })
    }

    // const bulkContactSelected = (e) => {
    //     console.log('bulkContactSelected', contactsIds, e.Contact_Id, [...contactsIds, e.Contact_Id])

    //     let newArray = [...contactsIds, e.Contact_Id];
    //     setContactIds(newArray)

    //     onChange({ value: newArray.map(g => { return { ID: g } as IStaff }) });

    //     console.log('bulkContactSelected', newArray?.length)
    // }


    const handleToolBarClick = (e) => {
        let toolName = e.toolName || "";
        if (toolName === "remove") {
            let newArray = [...bulkContactIds];
            newArray.splice(newArray.indexOf(selectedId), 1)
            //setContactIds(newArray)
            dispatch(TicketSlice.SetBulkContacts(newArray.map(g => { return { ID: g } as IStaff })))
        }
    };

    //Set the Client
    useEffect(() => {
        //Single end user
        //if (bulkUsers.length === 1)
        //    dispatch(TicketSlice.SetEndUserUid(bulkUsers[0].UId))
        if (bulkUsers?.length > 0) {
            //No client / project etc.
            let clients = [...new Set(bulkUsers.map(item => item.Company_Id))];
            console.log('multiple clients?', clients)
            dispatch(TicketSlice.SetEndUserUid(null))
            dispatch(TicketSlice.SetEndUserName(""))
            dispatch(TicketSlice.SetEndUser(null))
            dispatch(TicketSlice.SetForm(null))
            if (clients.length === 1) {
                dispatch(TicketSlice.SetClient(clients[0]))
            } else {
                dispatch(TicketSlice.SetProject(null))
            }
        }

    }, [bulkUsers])

    return (
        <div>
            <ListBox
                style={{ height: 100, width: "100%" }}
                data={bulkUsersFormatted}
                textField="Display_Name"
                selectedField={SELECTED_FIELD}
                onItemClick={(e: ListBoxItemClickEvent) => setSelectedId(e.dataItem.ID)}
                toolbar={() => {
                    return (
                        <ListBoxToolbar
                            dataConnected={null}
                            data={bulkUsersFormatted}
                            selectedField={SELECTED_FIELD}
                            tools={[
                                "remove",
                            ]}
                            onToolClick={handleToolBarClick}
                        />
                    );
                }
                }
            />
        </div>
    )
}

export default BulkContacts;